/* eslint-disable no-unused-vars */
import _kebabCase from 'lodash/kebabCase';
import { Google, Pixall } from '../analytics/index.js';

/**
 * @summary Sends event when primary & secondary articles are clicked
 * @cmp first_article | cntnr-art-sub-#
 * @events event1
 */
export async function researchArticleClick(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    event,
    data = {}
  } = metadata;
  const {
    articleTitle = '',
    pageType = '',
    index,
    referenceData = {}
  } = data;
  const articleIndex = index || 0;
  const cmp = articleIndex === 0 ? 'first_article' : `cntnr-art-sub-${articleIndex - 1}`;
  const linkcopy = _kebabCase(articleTitle);
  const isImage = referenceData?.referenceType === 'image' || false;
  const articleCategory = _kebabCase(referenceData?.articleCategory);
  let gaData = null;
  gaData = {
    eventElement: 'editorial',
    eventNonInteractive: false
  };
  if (isImage) {
    gaData = {
      ...gaData,
      eventResult: `image::article_${articleCategory}::${linkcopy}`
    };
  } else {
    // article
    gaData = {
      ...gaData,
      eventResult: `text-link::article_${articleCategory}::${linkcopy}`
    };
  }
  Google.sendClickEvent({
    event: 'analytics_event',
    ...gaData
  }, option);
  return {
    cmp
  };
}
export async function styleReviewsLinkClick(metadata, option) {
  const {
    event,
    pageType,
    bodyStyle,
    catalog,
    makeId,
    makeName,
    modelId,
    modelName,
    description
  } = metadata || {};
  const link = event && event.target && event.target.href && new URL(event.target.href);
  const linkcopy = link?.pathname?.replace(/[/\\#^+()$~%.,'":*?<>{}!@]/g, '').replace(/\s/gi, '-').toLowerCase();
  const gaData = {
    event: 'analytics_event',
    eventElement: pageType,
    eventResult: `text-link::ymm_new::${linkcopy}`,
    eventNonInteractive: false,
    eventData: {
      bodyStyle,
      catalog,
      makeId,
      makeName,
      modelId,
      modelName,
      description
    }
  };
  Google.sendClickEvent({
    ...gaData
  }, option);
  return {
    linkcopy
  };
}

/**
 * @summary Sends Analytics event when article cta is clicked
 * @cmp all_art
 * @events event1
 */
export function researchBtnCTAClick(_temp, option) {
  let {
    data = {},
    event
  } = _temp === void 0 ? {} : _temp;
  const {
    pageType = 'research',
    label = '',
    eventNonInteractive = null
  } = data;
  const cmp = 'all_art';
  const linkCopy = _kebabCase(label);
  Google.sendClickEvent({
    event: 'analytics_event',
    eventElement: 'editorial',
    eventResult: `cta::editorial::${linkCopy}`,
    eventNonInteractive: eventNonInteractive !== null ? eventNonInteractive : false
  }, option);
  return {
    cmp,
    pageType
  };
}

/**
 * @summary Sends Adobe event when DHS video play button is clicked
 * @cmp dhs_vid_ply
 * @events event1, event32
 */
export const researchVideoPlayClick = function (_temp2, option) {
  let {
    event,
    data = {}
  } = _temp2 === void 0 ? {} : _temp2;
  const cmp = 'dhs_vid_ply';
  return {
    cmp
  };
};

/**
 * @summary Sends Adobe event when CPO read more is clicked
 * @cmp cpo_rm_cta
 * @events event1
 */
export const researchCPOReadMoreClick = function (_temp3, option) {
  let {
    event,
    data
  } = _temp3 === void 0 ? {} : _temp3;
  const cmp = 'cpo_rm_cta';
  return {
    cmp
  };
};

/**
 * @summary Sends Adobe event when CPO car research button is clicked
 * @cmp cpo_rsch_cta
 * @events event1
 */
export const researchCPOCarSearchClick = function (_temp4, option) {
  let {
    event,
    data
  } = _temp4 === void 0 ? {} : _temp4;
  const cmp = 'cpo_rsch_cta';
  return {
    cmp
  };
};

/**
 * @summary Sends Adobe/Google event when Market Value button is clicked
 * @cmp find_nxt_car
 * @events event1
 */
export const marketValueCTAClick = function (_temp5, option) {
  let {
    event,
    data,
    dataLayer
  } = _temp5 === void 0 ? {} : _temp5;
  const cmp = 'find_nxt_car';
  Google.sendClickEvent({
    eventElement: 'search-car',
    eventResult: 'cta::srp::find-your-next-car',
    eventNonInteractive: true,
    eventData: {}
  }, option);
  Pixall.sendClickEvent({
    eventSource: 'button',
    label: 'cta::srp::find-your-next-car',
    hasListingType: false
  }, dataLayer, option);
  return {
    cmp
  };
};

/**
 * @summary Sends Analytics event when Market Value LINK is clicked
 * @cmp srch_avl_v
 * @events event1
 */
export const marketValueLINKClick = function (_temp6, option) {
  let {
    event,
    data
  } = _temp6 === void 0 ? {} : _temp6;
  const cmp = 'srch_avl_v';
  return {
    cmp
  };
};
export default {
  researchArticleClick,
  researchBtnCTAClick,
  researchVideoPlayClick,
  researchCPOReadMoreClick,
  researchCPOCarSearchClick,
  styleReviewsLinkClick,
  marketValueCTAClick,
  marketValueLINKClick
};